export class PrintError extends Error {
  constructor(msg?: string) {
    super(msg ? `PrintError: ${msg}` : "PrintError");
  }
}
